import { makeStyles } from '@material-ui/styles';

export const useLoaderStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: (props) => (props.mobile ? 120 : 136),
    height: (props) => (props.mobile ? 45 : 50),
  },
}));
